import { formatStringList } from "utils";

export const earnLiterals = {
  vaultWarningToast: {
    message: (nonActiveCurrencies: string[]) =>
      `Withdrawals for ${formatStringList(
        nonActiveCurrencies
      )} vaults have been partially halted. Withdrawals will be resumed shortly.`,
  },
};
